/**
 * Cases-pagina: filterknoppen (cases-intro) + kaarten (cases-showcase).
 * Koppel beide secties met dezelfde "Group ID" in de theme editor.
 */
(function () {
  function setActiveFilter(bar, activeBtn) {
    bar.querySelectorAll('[data-case-filter]').forEach(function (b) {
      b.setAttribute('aria-pressed', 'false');
    });
    activeBtn.setAttribute('aria-pressed', 'true');
  }

  function applyFilter(showcase, filter) {
    var cards = showcase.querySelectorAll('[data-case-category]');
      cards.forEach(function (card) {
      var cat = (card.getAttribute('data-case-category') || '').toLowerCase();
      var show = filter === 'all' || cat === filter;
      if (show) {
        card.removeAttribute('hidden');
      } else {
        card.setAttribute('hidden', '');
      }
    });
  }

  function initCasesFilters() {
    document.querySelectorAll('[data-cases-filters]').forEach(function (bar) {
      var group = bar.getAttribute('data-cases-group');
      if (!group) return;

      var safe =
        typeof CSS !== 'undefined' && CSS.escape
          ? CSS.escape(group)
          : group.replace(/[^a-zA-Z0-9_-]/g, '');
      var showcase = document.querySelector(
        '[data-cases-showcase][data-cases-group="' + safe + '"]'
      );
      if (!showcase) return;

      bar.querySelectorAll('[data-case-filter]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var filter = (btn.getAttribute('data-case-filter') || 'all').toLowerCase();
          setActiveFilter(bar, btn);
          applyFilter(showcase, filter);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCasesFilters);
  } else {
    initCasesFilters();
  }
})();
